import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NoteViewModel } from '../../models/rmd.models';
import { RmdTrackerApiService } from '../../services/rmd-tracker.service'; // Import NoteService

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.css']
})
export class AddNoteComponent implements OnInit {
  @Input() accounts: any[] = [];
  @Output() noteAdded = new EventEmitter<NoteViewModel>(); // Event emitter to notify parent component
  noteForm: FormGroup;

  constructor(private fb: FormBuilder, private rmdTrackerApi: RmdTrackerApiService) {
    this.noteForm = this.fb.group({
      account: [null, Validators.required],
      notes: ['', Validators.required],
      preserve: [false]
    });
  }

  ngOnInit(): void {
    this.resetForm();
  }

  ngOnChanges(): void {
    this.resetForm();
  }

  resetForm(): void {
    if (this.accounts.length > 0) {
      this.noteForm.patchValue({ account: this.accounts[0] });
    }
    this.noteForm.reset({
      account: this.accounts.length > 0 ? this.accounts[0] : null,
      notes: '',
      preserve: false
    });
  }

  onSubmit(): void {
    if (this.noteForm.valid) {
      const newNote: NoteViewModel = {
        id: 0,
        notes: this.noteForm.value.notes,
        objectId: this.noteForm.value.account.accountId,
        notesType: 2, // Assuming 2 is the type for account notes
        dateCreated: new Date(),
        noteStatus: 'Active',
        systemLoginCreated: '', // This should be set to the current user's ID
        systemLoginChanged: '',
        isDeleted: false,
        isPrivate: false,
        preserve: this.noteForm.value.preserve,
        fullName: '', // This should be set to the current user's full name
        impersonatorLoginCreated: ''
      };

      this.rmdTrackerApi.addNote(newNote).subscribe(
        response => {
          //console.log('Note added successfully', response);
          this.noteAdded.emit(response); // Notify parent component
          this.resetForm(); // Reset the form
        },
        error => {
          console.error('Error adding note', error);
          // Handle error (e.g., show an error message)
        }
      );
    }
  }
}
